import { ReactNode } from 'react';
import clsx from 'clsx';
import styles from './SourceBadge.module.scss';
import { SOURCE_BADGE_TONE } from './constants';
import { SourceBadgeTone } from './types';

interface SourceBadgeProps {
    value: string;
    className?: string;
    tone?: SourceBadgeTone;
    trailing?: ReactNode;
}

const SourceBadge = ({ value, className, tone = SOURCE_BADGE_TONE.VERIFIED, trailing }: SourceBadgeProps) => (
    <div className={clsx(styles.SourceBadge, { [styles.Neutral]: tone === SOURCE_BADGE_TONE.NEUTRAL }, className)}>
        <span className={styles.SourceBadgeLabel}>Source:</span>
        <span className={styles.SourceBadgeValue}>{value}</span>
        {trailing && <span className={styles.Trailing}>{trailing}</span>}
    </div>
);

export default SourceBadge;
